import { render, staticRenderFns } from "./MoneyIcon.vue?vue&type=template&id=99658db2&"
import script from "./MoneyIcon.vue?vue&type=script&lang=js&"
export * from "./MoneyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports